module.exports = __webpack_public_path__ + "img/uniones-nipples (2).af27a006.jpg";